module.exports = __webpack_public_path__ + "static/media/italy.60e9a6f4.svg";